// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"_38858da7","innerWrapper":"_94a285ec","subheader":"_9c1e417a","cta":"_7f77e857","backgroundImage":"_d20bc088"};